import { call, put, select } from 'redux-saga/effects';

import {
    addToCart,
    cancelHideCartConfirmTimer,
    resetHideCartConfirmTimer,
    setFreeShippingFlag,
    showProductActionError,
    hideProductActionError,
    hideCartConfirm,
    addToCartReady
} from '../actions/productActions';

import template from 'product-add-to-cart.j2';

import { debug, error } from '../../../core/js/utils/logger';

import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { onStateChange as commonOnStateChange } from '../utils/productComponentUtils';
import productUtils from '../utils/utils';
import { isFormValid } from '../../../core/js/utils/errorHandling';
import { mDom } from '../../../core/js/utils/renderUtils';

function attachCartConfirmClickRemoval(scopedEvent, store) {
    const product = productUtils.getTargetedProduct(store.getState(), this);

    if (!_.isEmpty(product) && product.productAddToCart.isSuccess) {
        $(document).one(scopedEvent, (event) => {
            if (!$(event.target).closest('.js-cart-confirm').length) {
                store.dispatch(hideCartConfirm());
            }
        });
    }
}

function validateAddToCart(component, e) {
    const state = component.getState();
    const product = component.getTargetedProduct(state);

    const formEl = $(component.templateLocation).parents('.js-product-add-form');
    const valid = isFormValid(formEl);
    const skuAvailableStatus = _.get(product, 'selectedSku.sku.availableStatus');
    const isSkuPurchasable = productUtils.isSkuPurchasable(_.toString(skuAvailableStatus));
    const haveSku = !_.isEmpty(_.get(product, 'selectedSku.sku', {}));

    if (haveSku && !isSkuPurchasable) {
        return;
    }

    if (valid) {
        const discountableSubtotal = _.get(state, 'core.cart.discountableSubtotal', 0);
        const qualifierThreshold = _.get(state, 'core.constants.cartQualifierThreshold', 0);

        component.dispatch(hideProductActionError(component));
        component.dispatch(addToCart(e, component));

        if (discountableSubtotal >= qualifierThreshold) {
            component.dispatch(setFreeShippingFlag(true));
        }
    } else {
        component.dispatch(showProductActionError(component, 'ADD_TO_BASKET', product.product.isEgiftCard));
    }
}

function onStateChange(store, watchValue, oldValue, newValue) {
    if (commonOnStateChange.call(this, store, watchValue, oldValue, newValue)) {
        attachCartConfirmClickRemoval(this.scopedEvent('touchend click'), store);
    }
}

/**
 * Attach component events to DOM
 * @param {object} store The store
 */
function attachEvents(store) {
    const state = store.getState();
    const isTouchDevice = _.get(this.getDeviceCharacteristics(), 'is_touch', false);

    if (!isTouchDevice) {
        // cart confirm timer events
        $(document).on(this.scopedEvent('mouseenter'), '.js-cart-confirm', (e) => {
            if (store.getState().core.cart.isConfirmTimerActive) {
                this.dispatch(cancelHideCartConfirmTimer());
            }
        });

        $(document).on(this.scopedEvent('mouseleave'), '.js-cart-confirm', (e) => {
            if (!store.getState().core.cart.isConfirmTimerActive) {
                this.dispatch(resetHideCartConfirmTimer());
            }
        });
    }

    // adding to cart
    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-add-to-cart'), (e) => {
        e.preventDefault();
        validateAddToCart(this, e);
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-wishlist-add-to-cart'), (e) => {
        e.preventDefault();
        validateAddToCart(this, e);
    });

    $(window).on('pageshow', (event) => {
        this.dispatch(hideCartConfirm());
    });
}

function afterConstruction(store) {
    store.dispatch(addToCartReady(this));
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-pdp .dom-main-product .dom-add-to-cart',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        watch: 'product.productAddToCart',
        template: template,
        name: 'productAddToCartComponent',
        forFamilyProduct: false,
        replace: false,
        renderType: mDom,
        afterConstruction: afterConstruction
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
